/**
 * plugins/index.js
 *
 * Automatically included in `./src/main.js`
 */

// Plugins
import vuetify from './vuetify'
import router from '@/router'
import { initSentry } from './sentry'

// Pinia
import {createPinia} from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

export function registerPlugins (app) {
  initSentry(app, router)

  app
    .use(vuetify)
    .use(router)
    .use(pinia)
}
